import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Button, Typography, Container, Grid } from "@mui/material";
import { ReactComponent as Logo } from "../../Images/Dashboard/logo1.svg";
import { ReactComponent as Logo2 } from "../../Images/Dashboard/logo2.svg";
import LoginBackground from "../../Images/Login/LoginBackground.jpg";

const InvitationResponse = () => {
  const { action, email } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Processing your invitation...");
  const [success, setSuccess] = useState(null);
  const apiCalled = useRef(false);

  useEffect(() => {
    if (apiCalled.current) return;
    apiCalled.current = true;

    const handleInvitation = async () => {
      try {
        // Get API URL with fallback, ensuring no double slashes
        const baseUrl = (process.env.REACT_APP_SERVER_DOMAIN || 'http://localhost:8000').replace(/\/$/, '');
        const url = `${baseUrl}/api/teammembers/${action}-invitation/${email}`;
        console.log("Calling API:", url);
        const res = await axios.get(url);
        setMessage(res.data.message || "Success!");
        setSuccess(true);
      } catch (err) {
        console.error("Error details:", err);
        setMessage(
          err.response?.data?.error || err.response?.data?.message || "Something went wrong."
        );
        setSuccess(false);
      }
    };
    handleInvitation();
    // eslint-disable-next-line
  }, [action, email]);

  const handleGoToLogin = () => {
    navigate("/", { replace: true });
  };

  // Determine message type for styling and button visibility
  const isSuccess = success === true && message.toLowerCase().includes("accepted");
  const isRejected = message.toLowerCase().includes("rejected") || message.toLowerCase().includes("expired");
  const isError = success === false && !isRejected;

  return (
    <Box
      sx={{
        height: "100vh",
        backgroundColor: "#ffffff",
        fontFamily: "Figtree, sans-serif",
      }}
    >
      <Grid container sx={{ height: "100%" }}>
        {/* Left Column - Invitation Response */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: 3,
          }}
        >
          <Container maxWidth="sm">
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxWidth: 450,
                mx: "auto",
                p: 3,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 4,
                }}
              >
                <Logo height={30} />
                <Logo2 height={30} />
              </Box>

              <Box
                sx={{
                  p: 3,
                  mb: 4,
                  borderRadius: 3,
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                  background: isSuccess
                    ? "#e8f5e9"
                    : isError
                    ? "#ffebee"
                    : isRejected
                    ? "#f5f5f5"
                    : "#f8f9fa",
                  border: isSuccess
                    ? "1px solid #a5d6a7"
                    : isError
                    ? "1px solid #ffcdd2"
                    : isRejected
                    ? "1px solid #e0e0e0"
                    : "1px solid #e0e0e0",
                  textAlign: "center",
                  minHeight: 80,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Figtree, sans-serif",
                    fontSize: "1.15rem",
                    lineHeight: 1.7,
                    color: isSuccess
                      ? "#2e7d32"
                      : isError
                      ? "#c62828"
                      : isRejected
                      ? "#616161"
                      : "#333",
                    fontWeight: 500,
                  }}
                >
                  {message}
                </Typography>
              </Box>
              {/* Always show button now */}
              <Button
                onClick={handleGoToLogin}
                fullWidth
                variant="contained"
                sx={{
                  mt: 1,
                  mb: 2,
                  py: 1.5,
                  backgroundColor: isSuccess ? "#43a047" : isError ? "#e53935" : "#a0eaa3",
                  color: "white",
                  "&:hover": { backgroundColor: isSuccess ? "#388e3c" : isError ? "#b71c1c" : "#8ad28d" },
                  borderRadius: "28px",
                  textTransform: "none",
                  fontWeight: "medium",
                  fontSize: "1rem",
                  fontFamily: "Figtree, sans-serif",
                }}
              >
                Go to Login
              </Button>
            </Box>
          </Container>
        </Grid>

        {/* Right Column - Image */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: { xs: "none", md: "block" },
            backgroundImage: `url(${LoginBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </Grid>
    </Box>
  );
};

export default InvitationResponse; 